// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"2":"blogPost","239":"blog","631":"contact"}[chunkId] + "." + {"2":"9ed3700b","239":"51f68241","631":"1b97c717"}[chunkId] + ".css";
};